import styled from "styled-components";

const focusRing = "0 0 0 3px rgba(76, 175, 80, 0.2)";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(26, 46, 64, 0.24);
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y;

  @media (max-width: 1024px) {
    align-items: stretch;
    justify-content: flex-start;
    padding: 0;
  }

  @media (max-width: 480px) {
    padding: 0;
  }
`;

export const FormWrapper = styled.div`
  width: min(1100px, 100%);
  height: min(94dvh, 920px);
  min-height: 92dvh;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  padding: 1rem;
  border-radius: 18px;
  background: var(--gris-clair, #f8f9fa);
  border: 1px solid #d9e4ef;
  box-shadow: 0 18px 36px rgba(10, 24, 38, 0.22);
  overflow-y: auto;
  overflow-x: hidden;
  font-family: "Roboto", sans-serif;

  @media (max-width: 1024px) {
    gap: 0.55rem;
    height: auto;
    min-height: 100svh;
    max-height: none;
    width: 100vw;
    padding:
      env(safe-area-inset-top, 0px)
      0
      env(safe-area-inset-bottom, 0px);
    border-radius: 0;
    border: none;
    box-shadow: none;
    background: var(--gris-clair, #f8f9fa);
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
  }

  @media (max-width: 480px) {
    width: 100%;
    height: auto;
    min-height: 100svh;
    max-height: none;
    border-radius: 0;
    border: none;
    padding:
      env(safe-area-inset-top, 0px)
      0
      env(safe-area-inset-bottom, 0px);
  }
`;

export const FormBlock = styled.div`
  flex-shrink: 0;
  width: 100%;
  min-width: 0;
  background: #ffffff;
  border: 1px solid #dce6f0;
  border-radius: 12px;
  padding: 0.92rem;
  box-shadow: 0 8px 18px rgba(26, 46, 64, 0.08);
  transition: opacity 0.2s ease;
  overflow-x: hidden;

  @media (max-width: 1024px) {
    border-radius: 12px;
    padding: 0.68rem;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
  }

  @media (max-width: 480px) {
    border-radius: 10px;
    padding: 0.62rem;
  }

  @media (max-width: 360px) {
    border-radius: 9px;
    padding: 0.55rem;
  }
`;

export const FormHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.6rem;
  margin-bottom: 0.65rem;
  padding: 0.62rem 0.74rem;
  border-radius: 10px;
  border: 1px solid #d8e4ef;
  background: #ffffff;

  @media (max-width: 480px) {
    align-items: flex-start;
    flex-wrap: wrap;
    row-gap: 0.45rem;
    padding: 0.54rem 0.58rem;
  }
`;

export const FormHeaderActions = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.38rem;
  flex-shrink: 0;

  button {
    border-color: #d2deea !important;
    background: #ffffff !important;
    color: #35506a !important;
  }

  @media (max-width: 480px) {
    margin-left: auto;
  }
`;

export const FormSectionToggle = styled.button`
  min-height: 34px;
  padding: 0.35rem 0.62rem;
  border-radius: 999px;
  border: 1px solid #d2deea;
  background: #f8fbff;
  color: #35506a;
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  white-space: nowrap;

  @media (max-width: 480px) {
    min-height: 36px;
    font-size: 0.76rem;
    padding: 0.36rem 0.6rem;
  }
`;

export const FormTitle = styled.h2`
  margin: 0;
  color: var(--bleu-mineral, #1a2e40);
  font-family: "Poppins", sans-serif;
  font-size: 1.15rem;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: 0.2px;
  flex: 1;
  min-width: 0;

  @media (max-width: 1024px) {
    font-size: 1.12rem;
  }
`;

export const FormSubtitle = styled.p`
  margin: 0.35rem 0 0.75rem 0;
  color: #5f7082;
  font-size: 0.85rem;
  line-height: 1.45;

  @media (max-width: 1024px) {
    margin-bottom: 0.65rem;
    font-size: 0.8rem;
  }
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  gap: 0.5rem;

  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

export const Input = styled.input`
  width: 100%;
  min-height: 42px;
  border-radius: 10px;
  border: 1px solid #cdd9e4;
  background: #fff;
  color: var(--bleu-mineral, #1a2e40);
  font-size: 0.95rem;
  padding: 0.62rem 0.78rem;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:focus {
    outline: none;
    border-color: var(--vert-vitalite, #4caf50);
    box-shadow: ${focusRing};
  }

  @media (max-width: 1024px) {
    min-height: 44px;
    font-size: 16px;
  }
`;

export const SearchField = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 0.5rem;
  padding: 0.28rem 0.34rem 0.28rem 0.72rem;
  border: 1px solid #d4e0ec;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(26, 46, 64, 0.05);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  min-width: 0;

  &:focus-within {
    border-color: var(--vert-vitalite, #4caf50);
    box-shadow: ${focusRing};
  }

  @media (max-width: 1024px) {
    padding: 0.24rem 0.3rem 0.24rem 0.62rem;
  }

  @media (max-width: 480px) {
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 0.28rem;
    border-width: 1px;
    border-radius: 9px;
    padding: 0.18rem 0.24rem 0.18rem 0.44rem;
  }
`;

export const SearchInput = styled(Input)`
  border: none;
  background: transparent;
  padding: 0.55rem 0.15rem;
  min-height: auto;
  min-width: 0;

  &:focus {
    border: none;
    box-shadow: none;
  }

  @media (max-width: 480px) {
    padding: 0.4rem 0.04rem;
    font-size: 16px;
  }
`;

export const SearchActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.35rem;
  flex-shrink: 0;
  min-width: 0;

  @media (max-width: 480px) {
    gap: 0.3rem;
  }
`;

export const TinyIconButton = styled.button`
  width: 38px;
  height: 38px;
  border: 1px solid ${(props) => (props.$primary ? "#3f9a51" : "#d4dee9")};
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: ${(props) => (props.$primary
    ? "var(--vert-vitalite, #4caf50)"
    : "#ffffff")};
  color: ${(props) => (props.$primary ? "#fff" : "var(--bleu-mineral, #1a2e40)")};
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, opacity 0.15s ease;

  &:hover:not(:disabled) {
    background: ${(props) => (props.$primary ? "#469b4a" : "#f4f8fc")};
    border-color: ${(props) => (props.$primary ? "#398a3d" : "#c3d3e2")};
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }

  @media (max-width: 1024px) {
    width: 40px;
    height: 40px;
    border-radius: 11px;
  }

  @media (max-width: 480px) {
    width: 38px;
    height: 38px;
    border-radius: 8px;
  }

  @media (max-width: 360px) {
    width: 30px;
    height: 30px;
    border-radius: 7px;
  }

  @media (hover: none) and (pointer: coarse) {
    &:hover:not(:disabled) {
      transform: none;
      box-shadow: none;
    }
  }
`;

export const QuickActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.75rem;

  @media (max-width: 1024px) {
    flex-wrap: wrap;
    overflow: visible;
    padding-bottom: 0;
    gap: 0.3rem;
    touch-action: manipulation;
  }

  @media (max-width: 480px) {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    width: 100%;
    margin-top: 0.55rem;
    gap: 0.3rem;
  }

  @media (max-width: 360px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const QuickActionChip = styled.button`
  min-height: 34px;
  padding: 0.34rem 0.72rem;
  border-radius: 999px;
  border: 1px solid ${(props) => (props.$active ? "#1f5077" : "#cfdeec")};
  background: ${(props) => (props.$active ? "#e9f2fb" : "#f8fbff")};
  color: ${(props) => (props.$active ? "#1f5077" : "#36526a")};
  font-size: 0.77rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  &:hover:not(:disabled) {
    border-color: ${(props) => (props.$active ? "#1f5077" : "#bdd2e6")};
    background: ${(props) => (props.$active ? "#e5eff9" : "#f3f8fd")};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  @media (max-width: 1024px) {
    min-height: 34px;
    padding: 0.32rem 0.7rem;
  }

  @media (max-width: 480px) {
    min-height: 36px;
    width: 100%;
    min-width: 0;
    border-radius: 8px;
    padding: 0.34rem 0.4rem;
    font-size: 0.78rem;
    text-align: center;
    justify-content: center;
    white-space: normal;
    line-height: 1.25;
    gap: 0.25rem;
  }

  @media (max-width: 360px) {
    font-size: 0.74rem;
  }
`;

export const SuggestionPanel = styled.div`
  margin-top: 0.75rem;
  width: 100%;
  min-width: 0;
  padding: 0.8rem;
  border-radius: 12px;
  border: 1px solid #dce6f0;
  background: #ffffff;
  box-shadow: 0 6px 16px rgba(22, 39, 56, 0.06);
  display: flex;
  flex-direction: column;
  gap: 0.82rem;

  @media (max-width: 1024px) {
    padding: 0.66rem;
    gap: 0.68rem;
  }

  @media (max-width: 480px) {
    padding: 0.58rem;
    border-radius: 10px;
  }
`;

export const SuggestionSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.42rem;
  border: none;
  border-radius: 0;
  padding: 0;
  background: transparent;

  @media (max-width: 480px) {
    gap: 0.38rem;
  }
`;

export const SuggestionSectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.02rem 0.14rem 0.42rem;
  border-bottom: 1px solid #e4edf5;

  > span {
    flex-shrink: 0;
  }

  @media (max-width: 480px) {
    flex-wrap: wrap;
    row-gap: 0.3rem;
    padding-bottom: 0.32rem;
  }
`;

export const SuggestionSectionTitle = styled.h4`
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.36rem;
  color: ${(props) => (props.$variant === "favorites" ? "#8a6500" : "#1e4f75")};
  font-size: 0.88rem;
  font-weight: 800;
  min-width: 0;
  line-height: 1.2;

  svg {
    color: ${(props) => (props.$variant === "favorites" ? "#d39a1a" : "#2c6e9b")};
  }

  @media (max-width: 480px) {
    font-size: 0.84rem;
  }
`;

export const SuggestionList = styled.div`
  display: grid;
  gap: 0.48rem;
  width: 100%;
  min-width: 0;

  @media (max-width: 480px) {
    gap: 0.42rem;
  }
`;

export const SuggestionFooter = styled.div`
  display: flex;
  justify-content: center;
  padding: 0.35rem 0 0.15rem;

  @media (max-width: 480px) {
    padding-top: 0.5rem;
  }
`;

export const Pagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  margin-top: 0.5rem;
`;

export const PaginationButton = styled.button`
  width: 30px;
  height: 30px;
  border-radius: 999px;
  border: 1px solid #d7dee6;
  background: white;
  cursor: pointer;

  &:disabled {
    opacity: 0.35;
    cursor: default;
  }

  &:not(:disabled):hover {
    background: #f5f7fa;
  }
`;

export const PaginationInfo = styled.span`
  font-size: 0.85rem;
  color: #5f7387;
  font-weight: 600;
`;

export const LoadMoreButton = styled.button`
  border: none;
  background: transparent;
  color: #5f7387;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0.3rem 0.5rem;
  transition: color 0.15s ease;

  &:hover:not(:disabled) {
    color: #1f5077;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const SuggestionItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 0;
  border: 1px solid ${(props) => (props.$variant === "favorites" ? "#ead7a8" : "#d8e4ef")};
  border-radius: 10px;
  background: ${(props) => (props.$variant === "favorites" ? "#fffdf6" : "#fbfdff")};
  padding: 0.42rem;
  box-sizing: border-box;

  @media (max-width: 480px) {
    border-radius: 9px;
    padding: 0.36rem;
    gap: 0.4rem;
  }
`;

export const SuggestionRow = styled.div``;

export const SuggestionMeal = styled.div`
  border: none;
  background: transparent;
  border-radius: 8px;
  min-height: 58px;
  padding: 0.48rem 0.62rem;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-items: center;
  justify-items: end;
  gap: 0.5rem;
  cursor: default;

  @media (min-width: 650px) {
    
    > :last-child {
      box-sizing: border-box;
    }
  }
`;

export const SuggestionActions = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.4rem;
  min-width: 0;
  flex-shrink: 0;
  justify-self: end;

  @media (max-width: 480px) {
    gap: 0.25rem;
  }
`;

export const SuggestionMainContent = styled.div`
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.52rem;
  width: 100%;
  min-width: 0;

  @media (max-width: 480px) {
    grid-template-columns: 34px minmax(0, 1fr) auto;
    gap: 0.45rem;
  }
`;

export const SuggestionImageFrame = styled.span`
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid #d6e2ed;
  background: #eef4fa;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;

  @media (max-width: 480px) {
    width: 34px;
    height: 34px;
    border-radius: 9px;
  }
`;

export const SuggestionImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const SuggestionImageFallback = styled.span`
  color: #51708e;
  font-size: 0.78rem;
  font-weight: 800;
  text-transform: uppercase;
  line-height: 1;
`;

export const SuggestionText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.24rem;
  min-width: 0;
`;

export const SuggestionItemName = styled.span`
  color: var(--bleu-mineral, #1a2e40);
  font-size: 0.94rem;
  font-weight: 700;
  line-height: 1.28;
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 480px) {
    font-size: 0.88rem;
  }
`;

export const SuggestionItemMeta = styled.div`
  color: #6b7d8f;
  font-size: 0.78rem;
  font-weight: 500;
  line-height: 1.2;
  display: flex;
  align-items: center;
  gap: 0.35rem;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 480px) {
    font-size: 0.74rem;
  }
`;

export const FiltersPanel = styled.div`
  margin-top: 0.75rem;
  padding: 0.78rem;
  border-radius: 12px;
  border: 1px solid #dce6f0;
  background: #f8fbff;
  box-shadow: 0 4px 14px rgba(22, 39, 56, 0.05);

  @media (max-width: 1024px) {
    margin-top: 0.52rem;
    padding: 0.55rem;
    border-radius: 10px;
  }

  @media (max-width: 480px) {
    margin-top: 0.46rem;
    padding: 0.45rem;
    border-radius: 9px;
  }
`;

export const FiltersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.65rem;

  @media (max-width: 860px) {
    grid-template-columns: 1fr;
  }
`;

export const FilterField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
`;

export const FilterLabel = styled.label`
  margin: 0;
  color: var(--bleu-mineral, #1a2e40);
  font-size: 0.8rem;
  font-weight: 700;

  @media (max-width: 480px) {
    font-size: 0.72rem;
  }
`;

export const FilterSelect = styled(Input).attrs({ as: "select" })`
  font-size: 0.84rem;
  min-height: 40px;
  background: #fff;

  @media (max-width: 1024px) {
    font-size: 16px;
  }

  @media (max-width: 480px) {
    min-height: 36px;
  }
`;

export const KeyboardHint = styled.p`
  margin: 0.55rem 0 0 0;
  color: ${(props) => (props.$onDark ? "#607286" : "#66788a")};
  font-size: 0.75rem;
  line-height: 1.4;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.55rem;
  margin-top: 0.85rem;

  @media (max-width: 1024px) {
    flex-direction: column-reverse;
    align-items: stretch;
    margin-top: 0.6rem;
  }
`;

export const Btn = styled.button`
  min-height: 42px;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 0.62rem 0.95rem;
  font-weight: 700;
  font-size: 0.86rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, opacity 0.15s ease;

  &:hover:not(:disabled) {
    box-shadow: none;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  @media (max-width: 1024px) {
    min-height: 44px;
  }

  @media (max-width: 480px) {
    min-height: 40px;
    padding: 0.52rem 0.72rem;
    font-size: 0.8rem;
  }

  @media (hover: none) and (pointer: coarse) {
    &:hover:not(:disabled) {
      transform: none;
      box-shadow: none;
    }
  }
`;

export const BtnPrimary = styled(Btn)`
  background: var(--vert-vitalite, #4caf50);
  color: #fff;
  border-color: #3f9a51;

  &:hover:not(:disabled) {
    background: #469b4a;
    border-color: #398a3d;
  }
`;

export const BtnDanger = styled(Btn)`
  background: #ffffff;
  color: var(--bleu-mineral, #1a2e40);
  border-color: #ced9e5;
`;

export const BtnSecondary = styled(Btn)`
  background: #ffffff;
  color: var(--bleu-mineral, #1a2e40);
  border-color: #ced9e5;

  &:hover:not(:disabled) {
    background: #f5f9fd;
    border-color: #b8c9dc;
  }
`;

export const ResultsContainer = styled.section`
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  min-height: 0;
  border-radius: 14px;
  border: 1px solid #dce6f0;
  background: #fff;
  box-shadow: 0 8px 18px rgba(26, 46, 64, 0.08);
  overflow: visible;

  @media (max-width: 1024px) {
    flex: 0 0 auto;
    min-height: 0;
    border-radius: 12px;
    box-shadow: 0 6px 16px rgba(26, 46, 64, 0.08);
    overflow: visible;
  }
`;

export const ResultsHeader = styled.div`
  position: relative;
  padding: 0.9rem 1rem 0.7rem;
  border-bottom: 1px solid #dce6f0;
  background: linear-gradient(180deg, #f5f9fd 0%, #edf4fb 100%);

  p {
    color: #607286;
  }

  @media (max-width: 1024px) {
    padding: 0.75rem 0.75rem 0.65rem;
  }

  @media (max-width: 480px) {
    padding: 0.62rem 0.62rem 0.55rem;
  }
`;

export const ResultsHeaderTop = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.8rem;

  @media (max-width: 560px) {
    flex-direction: column;
    align-items: stretch;
    gap: 0.48rem;
  }

  @media (max-width: 480px) {
    gap: 0.55rem;
  }
`;

export const ResultsHeading = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ResultsTitle = styled.h3`
  margin: 0;
  color: var(--bleu-mineral, #1a2e40);
  font-family: "Poppins", sans-serif;
  font-size: 1.05rem;
  font-weight: 700;

  @media (max-width: 480px) {
    font-size: 1.05rem;
  }
`;

export const ResultsCountText = styled.p`
  margin: 0.25rem 0 0 0;
  color: #5f7286;
  font-size: 0.8rem;
  line-height: 1.35;

  @media (max-width: 480px) {
    margin-top: 0.18rem;
    font-size: 0.82rem;
  }
`;

export const HeaderActions = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  flex-shrink: 0;

  @media (max-width: 560px) {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.38rem;

    > button {
      width: 100%;
    }
  }
`;

export const HeaderMetaRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-top: 0.55rem;
`;

export const ResultsToolRow = styled.div`
  margin-top: 0.55rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
`;

export const ResultsBackButton = styled.button`
  min-height: 34px;
  padding: 0.34rem 0.72rem;
  border-radius: 999px;
  border: 1px solid #cfdeec;
  background: #f8fbff;
  color: #36526a;
  font-size: 0.77rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  &:hover:not(:disabled) {
    border-color: #bdd2e6;
    background: #f3f8fd;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  @media (max-width: 480px) {
    min-height: 36px;
    border-radius: 8px;
    padding: 0.34rem 0.6rem;
    font-size: 0.78rem;
  }
`;

export const MetaPill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.18rem 0.52rem;
  border-radius: 999px;
  border: 1px solid #d0deeb;
  background: #f4f8fc;
  color: #3d5a72;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1.2;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &.meta-pill-calories {
    border-color: rgba(229, 57, 53, 0.28);
    background: rgba(229, 57, 53, 0.1);
    color: #b42318;
  }

  &.meta-pill-nutriscore {
    border-color: rgba(15, 95, 198, 0.28);
    background: rgba(15, 95, 198, 0.1);
    color: #12436d;
  }

  @media (max-width: 480px) {
    font-size: 0.72rem;
    padding: 0.18rem 0.48rem;
    gap: 0.2rem;
  }
`;

export const WarningBox = styled.div`
  margin-top: 0.55rem;
  padding: 0.45rem 0.6rem;
  border-radius: 8px;
  border: 1px solid rgba(255, 193, 7, 0.4);
  background: #fff8e9;
  color: #9a6a00;
  font-size: 0.76rem;
  font-weight: 600;
`;

export const ResultsContent = styled.div`
  flex: 0 0 auto;
  overflow: visible;
  display: flex;
  flex-direction: column;
  gap: 0.72rem;
  padding: 0.85rem 1rem 1rem;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  touch-action: pan-y;

  @media (max-width: 1024px) {
    overflow: visible;
    gap: 0.48rem;
    padding: 0.72rem 0.74rem calc(env(safe-area-inset-bottom, 0px) + 0.82rem);
  }

  @media (max-width: 480px) {
    gap: 0.42rem;
    padding: 0.56rem 0.58rem calc(env(safe-area-inset-bottom, 0px) + 0.72rem);

    > * {
      min-width: 0;
      max-width: 100%;
    }
  }

  @media (max-width: 360px) {
    padding: 0.5rem 0.52rem calc(env(safe-area-inset-bottom, 0px) + 0.68rem);
  }
`;

export const ResultCard = styled.article`
  padding: 0.88rem;
  border-radius: 12px;
  border: 1px solid #dce6f0;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  box-shadow: 0 4px 14px rgba(22, 39, 56, 0.06);
  transition: border-color 0.15s ease, background 0.15s ease;
  cursor: pointer;

  &:hover,
  &:focus {
    outline: none;
    border-color: #bcd4eb;
    background: #f6fbff;
    box-shadow: 0 4px 14px rgba(22, 39, 56, 0.06);
  }

  &[data-focused="true"] {
    border-color: #9acbb0;
    background: #eef8f1;
  }

  @media (max-width: 1024px) {
    border-radius: 11px;
    padding: 0.78rem;
  }

  @media (max-width: 480px) {
    padding: 0.76rem;
    border-radius: 10px;
  }

  @media (hover: none) and (pointer: coarse) {
    &:hover,
    &:focus {
      background: #fff;
      box-shadow: 0 4px 14px rgba(22, 39, 56, 0.06);
      border-color: #d9e4ef;
    }
  }
`;

export const ResultRow = styled.div`
  display: grid;
  grid-template-columns: 88px minmax(0, 1fr) 220px;
  gap: 0.7rem;
  align-items: flex-start;

  @media (max-width: 900px) {
    grid-template-columns: 68px minmax(0, 1fr);
  }

  @media (max-width: 430px) {
    grid-template-columns: 56px minmax(0, 1fr);
    gap: 0.56rem;
  }

  @media (max-width: 360px) {
    grid-template-columns: 44px minmax(0, 1fr);
    gap: 0.38rem;
  }
`;

export const ProductImageButton = styled.button`
  border: 1px solid #d9e4ef;
  background: #f6f9fd;
  padding: 0;
  margin: 0;
  width: 88px;
  height: 88px;
  border-radius: 10px;
  cursor: zoom-in;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  &:focus-visible {
    outline: none;
    box-shadow: ${focusRing};
  }

  @media (max-width: 900px) {
    width: 68px;
    height: 68px;
  }

  @media (max-width: 430px) {
    width: 50px;
    height: 50px;
  }

  @media (max-width: 360px) {
    width: 44px;
    height: 44px;
  }
`;

export const ProductImageLarge = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 0.2rem;
  border-radius: inherit;
  background: #f7fbff;
`;

export const InfoColumn = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;

  @media (max-width: 480px) {
    gap: 0.28rem;
  }
`;

export const ResultIdentity = styled.div`
  min-width: 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;

  > div {
    min-width: 0;
    flex: 1;
  }

  > button {
    flex: 0 0 auto;
  }

  @media (max-width: 480px) {
    gap: 0.35rem;
  }
`;

export const Name = styled.h4`
  margin: 0;
  color: var(--bleu-mineral, #1a2e40);
  font-size: 0.96rem;
  font-weight: 700;
  line-height: 1.3;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  @media (max-width: 1024px) {
    font-size: 0.88rem;
  }

  @media (max-width: 480px) {
    font-size: 0.92rem;
    line-height: 1.24;
  }
`;

export const Brand = styled.p`
  margin: 0;
  color: #64748b;
  font-size: 0.79rem;
  font-weight: 600;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;

  @media (max-width: 1024px) {
    font-size: 0.78rem;
  }

  @media (max-width: 480px) {
    font-size: 0.76rem;
  }
`;

export const InfoText = styled.div`
  margin: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.35rem;
  color: #6d7f90;
  font-size: 0.75rem;
  min-width: 0;

  @media (max-width: 480px) {
    gap: 0.3rem;
    font-size: 0.75rem;
  }
`;

export const FoodFavoriteButton = styled(FormSectionToggle)``;

export const IngredientPreview = styled.p`
  margin: 0;
  color: #617386;
  font-size: 0.73rem;
  line-height: 1.35;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;

  @media (max-width: 480px) {
    font-size: 0.67rem;
    line-height: 1.26;
    -webkit-line-clamp: 2;
  }
`;

export const PremiumNotice = styled.div`
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.32rem;
  color: #7f8fa0;
  font-size: 0.73rem;
  font-weight: 600;

  svg {
    color: #f59e0b;
  }
`;

export const QuantityWrapper = styled.div`
  display: flex;
  gap: 0.4rem;
  border-radius: 10px;
  border: 1px solid #d8e4ef;
  background: #f8fbff;
  padding: 0.58rem;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.62);
  width: fit-content;

  ${({ $result }) => $result && `
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: center;
    gap: 0.42rem;
    padding: 0.5rem;

    > label,
    > div {
      grid-column: 1 / -1;
    }

    > label {
      font-size: 0.72rem;
    }

    > button {
      width: 100%;
      min-width: 0;
    }
  `}

  @media (max-width: 650px) {
    flex-wrap: wrap;
  }

  @media (max-width: 900px) {
    ${({ $result }) => $result && `
      grid-column: 1 / -1;
      grid-template-columns: auto minmax(0, 1fr) repeat(2, auto);
      align-self: stretch;

      > label,
      > div {
        grid-column: auto;
      }

      > label {
        white-space: nowrap;
      }

      > button {
        width: auto;
      }
    `}
  }

  @media (max-width: 650px) {
    ${({ $result }) => $result && `
      grid-template-columns: auto minmax(0, 1fr);

      > button {
        width: 100%;
      }
    `}
  }

  ${({ $compact }) => $compact && `
    align-self: flex-start;
    flex-direction: row;
    align-items: center;
    gap: 0.35rem;
    padding: 0.35rem;
    border-radius: 8px;

    > label {
      white-space: nowrap;
      font-size: 0.68rem;
    }

    > div {
      width: 145px;
      flex: 0 0 145px;
      grid-template-columns: 28px 1fr 28px;
      gap: 0.22rem;
    }

    input {
      min-height: 30px;
      padding: 0.25rem;
      font-size: 0.78rem;
    }

    > div > button {
      min-height: 30px;
      font-size: 0.9rem;
    }

    > button {
      min-width: 132px;
      width: 132px;
      height: 32px;
      min-height: 32px;
      max-height: 32px;
      padding: 0.25rem 0.45rem;
      font-size: 0.7rem;
      line-height: 1;
      white-space: nowrap;
    }
  `}

  > button {
    min-height: 34px;
    padding: 0.4rem 0.58rem;
    font-size: 0.76rem;
  }

  .button-row {
    display: flex;
    gap: 0.4rem;
  }
`;

export const QuantityLabel = styled.label`
  margin: 0;
  font-size: 0.76rem;
  font-weight: 700;
  color: var(--bleu-mineral, #1a2e40);

  @media (max-width: 1024px) {
    font-size: 0.69rem;
  }

  @media (max-width: 480px) {
    font-size: 0.76rem;
  }
`;

export const QuantityControls = styled.div`
  display: grid;
  grid-template-columns: 36px 1fr 36px;
  gap: 0.4rem;
  align-items: center;

  @media (max-width: 1024px) {
    grid-template-columns: 30px 1fr 30px;
    gap: 0.26rem;
  }

  @media (max-width: 480px) {
    grid-template-columns: 30px 1fr 30px;
    gap: 0.24rem;
  }

  @media (max-width: 360px) {
    grid-template-columns: 28px 1fr 28px;
  }
`;

export const QuantityAdjustButton = styled.button`
  min-height: 38px;
  border-radius: 8px;
  border: 1px solid #cfdeec;
  background: #ffffff;
  color: #35506a;
  font-weight: 800;
  font-size: 1rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  /* ==========================================================================
     CORRECTION CRITIQUE : DESACTIVE LA SÉLECTION ET LES MENUS CONTEXTUELS
     ========================================================================== */
  -webkit-touch-callout: none; /* Désactive le menu pop-up "Partager/Copier" sur iOS */
  -webkit-user-select: none;   /* Désactive la sélection de texte sur Safari */
  -moz-user-select: none;      /* Désactive la sélection de texte sur Firefox */
  -ms-user-select: none;       /* Désactive la sélection de texte sur Internet Explorer */
  user-select: none;           /* Règle standard pour Chrome, Edge et Opera */
  
  touch-action: manipulation;  /* Supprime le délai de double-tap sur mobile */

  &:hover:not(:disabled) {
    background: #f2f7fc;
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }

  @media (max-width: 480px) {
    min-height: 30px;
    border-radius: 6px;
    font-size: 0.9rem;
  }
`;

export const QuantityInput = styled(Input)`
  min-height: 38px;
  text-align: center;
  font-weight: 700;
  background: #fff;
  border-color: #cfdeec;

  @media (max-width: 1024px) {
    min-height: 32px;
    padding: 0.32rem 0.45rem;
    font-size: 0.78rem;
  }

  @media (max-width: 480px) {
    min-height: 30px;
    padding: 0.3rem 0.35rem;
    font-size: 0.84rem;
  }
`;

export const NutritionToggleButton = styled.button`
  display: flex;
  width: max-content;
  max-width: 100%;
  margin: 0.58rem auto 0;
  margin-inline: auto;
  border: 1px solid #d4e0ec;
  border-radius: 999px;
  background: #f6f9fd;
  color: #35506a;
  padding: 0.16rem 0.55rem;
  font-size: 0.73rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  align-items: center;
  justify-content: center;
  gap: 0.34rem;
  cursor: pointer;
  line-height: 1.2;
  transition: border-color 0.2s ease, background 0.2s ease, color 0.2s ease;

  ${({ $compact }) => $compact && `
    min-width: 90px;
    width: 90px;
    height: 32px;
    min-height: 32px;
    max-height: 32px;
    margin: 0;
    padding: 0.22rem 0.56rem;
    border-radius: 8px;
    font-size: 0.78rem;
    line-height: 1;
  `}

  @media (max-width: 480px) {
    ${({ $compact }) => $compact && `
      width: 112px;
      min-width: 112px;
      font-size: 0.7rem;
      padding-left: 0.35rem;
      padding-right: 0.35rem;
    `}
  }

  &:hover {
    border-color: #b8cce0;
    background: #eef4fa;
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px rgba(54, 126, 193, 0.2);
  }

  svg {
    width: 10px;
    height: 10px;
    transition: transform 0.2s ease;
  }

  &.active {
    color: #2f7d45;
    background: #eff9f1;
    border-color: #bfe0c8;
  }

  &.active svg {
    transform: rotate(180deg);
  }

  @media (max-width: 900px) {
    margin-top: 0.42rem;
    font-size: 0.72rem;
    gap: 0.32rem;
  }
`;

export const NutritionWrapper = styled.div`
  margin-top: 0.7rem;
  padding-top: 0.64rem;
  border-top: 1px solid #dce6f0;

  @media (max-width: 1024px) {
    margin-top: 0.42rem;
    padding-top: 0.38rem;
  }
`;

export const NutritionQuantity = styled.span`
  display: inline-block;
  margin-bottom: 0.45rem;
  color: #5f7286;
  font-size: 0.76rem;
  font-weight: 600;

  @media (max-width: 1024px) {
    margin-bottom: 0.24rem;
    font-size: 0.74rem;
  }
`;

export const NutritionDetailSection = styled.div`
  margin-top: 0.625rem;
  padding: 0;
  border: none;
  border-radius: 0;
  background: transparent;

  @media (max-width: 1024px) {
    margin-top: 0.54rem;
    padding: 0;
  }
`;

export const NutritionDetailSectionTitle = styled.div`
  margin-bottom: 0.5rem;
  font-size: 0.78rem;
  font-weight: 700;
  color: #5f7286;
  text-transform: uppercase;
  letter-spacing: 0.04em;

  @media (max-width: 1024px) {
    margin-bottom: 0.44rem;
    font-size: 0.78rem;
  }
`;

export const NutritionDetailText = styled.p`
  margin: 0;
  color: #5c6f82;
  font-size: 0.76rem;
  line-height: 1.5;
  word-break: break-word;

  @media (max-width: 1024px) {
    font-size: 0.76rem;
    line-height: 1.42;
  }
`;

export const NutritionIngredientsList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 0.5rem;
  min-width: 0;
  width: 100%;
  border: 1px solid #e1e5e9;
  border-radius: 6px;
  background: var(--gris-clair, #f8f9fa);
  padding: 0.7rem;
`;

export const NutritionIngredientChip = styled.span`
  background: ${(props) => (props.$muted ? "#f8fafc" : "#ffffff")};
  color: ${(props) => (props.$muted ? "#7b8794" : "#1f3346")};
  padding: 0.5rem;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  border: 1px solid #e1e5e9;
  line-height: 1.25;
  min-height: 38px;
  display: flex;
  align-items: center;
  max-width: 100%;
  word-break: break-word;

  @media (max-width: 1024px) {
    font-size: 0.8rem;
    padding: 0.48rem;
  }
`;

export const EcoScoreImage = styled.img`
  width: 50px;
  height: auto;
`;

export const EcoScoreWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
`;

export const StatusCard = styled.div`
  margin-top: 0.6rem;
  padding: 0.75rem 0.8rem;
  border-radius: 10px;
  border: 1px dashed #cad6e2;
  background: #f9fbfd;
`;

export const StateMessage = styled.p`
  margin: 0;
  color: #5f7082;
  font-size: 0.82rem;
  line-height: 1.4;
`;

export const VisuallyHidden = styled.div`
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
`;
